import en from './en';
import sv from './sv';

export type Translations = typeof en;

export const translations = {
  en,
  sv,
};

export type LanguageCode = keyof typeof translations;
